<template>
  <div>
    <v-row
      style="margin: 0;"
    >
      <v-col
        class="d-flex start align-center header-label"
      >
        {{ $t('people/person_document.type') }}
      </v-col>
      <v-col
        class="d-flex start align-center header-label"
      >
        {{ $t('people/person.validity') }}
      </v-col>
      <v-col
        class="d-flex justify-end header-label"
      >
        <table-row-actions-menu
          :data-index="itemIndex"
          :config="actionsConfig"
          :table-data="data"
        />
      </v-col>
    </v-row>

    <v-row
      style="margin: 0;"
    >
      <v-col
        class="driver-label"
      >
        {{ personDocumentType }}
      </v-col>

      <v-col
        class="driver-label"
      >
        {{ personDocumentValidity }}
      </v-col>
      <v-col />
    </v-row>

    <v-row
      style="margin: 0;"
    >
      <v-col
        class="d-flex justify-end"
      >
        <div>
          {{ $t('people/person_document.alarm_on') }}
        </div>
        <active-icon
          :cell-data="item.alarm_on || 0"
          class="mr-2 ml-2"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import TableRowActionsMenu from '@/global/components/table/components/TableRowActionsMenu.vue'
import ActiveIcon from './main-table/ActiveIcon.vue'
import { isFunction } from '@/global/utils/utils'
import { dateService, FORMATS } from '@/global/services/date'
import { showDetailsAction, deleteAction } from '@/global/components/table/helpers/tableActions'

export default {
  name: 'DocumentsGridBlock',

  components: {
    ActiveIcon,
    TableRowActionsMenu
  },

  props: {
    data: {
      type: Array,
      default: () => ([])
    },
    item: {
      type: Object,
      required: true,
      default: () => ({})
    },
    itemIndex: {
      type: Number,
      default: 0
    },
    blockConfig: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    actionsConfig () {
      return {
        tableConfig: {
          actionsConfig: [
            showDetailsAction(this.$t, (event) => this.onShowDocument(event)),
            deleteAction(this.$t, (event) => this.onDocumentDelete(event))
          ]
        }
      }
    },

    personDocumentType () {
      const { person_document_id: personDocumentType } = this.item || {}
      return personDocumentType?.display_name || '--'
    },

    personDocumentValidity () {
      const { valid_from: validityStart, valid_to: validityEnd } = this.item || {}
      const startDateFormatted = dateService.isValid(validityStart, FORMATS.isoDate, true) ? dateService.formatCustom(validityStart, FORMATS.isoDate, FORMATS.date) : '/'
      const endDateFormatted = dateService.isValid(validityEnd, FORMATS.isoDate, true) ? dateService.formatCustom(validityEnd, FORMATS.isoDate, FORMATS.date) : '/'
      return `${startDateFormatted} - ${endDateFormatted}`
    }
  },

  methods: {
    getAllItemDetails () {
      return [
        {
          label: this.$t('people/person.record_number'),
          value: this.item?.record_number || '--'
        }
      ]
    },

    onShowDocument (event) {
      const { onEdit } = this.blockConfig || {}
      if (isFunction(onEdit)) {
        onEdit(event)
      }
    },

    onDocumentDelete (event) {
      const { onDelete } = this.blockConfig || {}
      if (isFunction(onDelete)) {
        onDelete(event)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.driver-label {
  font-family: 'Satoshi', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0;
  color: #111827;
  align-items: center;
  padding-top: 0;
}

.header-label {
  padding-bottom: 0;
}

.driver-label--wrapper {
  display: flex;
  height: 48px;
  align-items: center;
}

.data-label {
  font-family: 'Satoshi', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0;
  color: #6B7280;
}

.data-value {
  font-family: 'Satoshi', sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0;
  color: #111827;
  text-align: right;
}
</style>
